import { render, staticRenderFns } from "./GIS.vue?vue&type=template&id=38664b15&scoped=true&"
import script from "./GIS.vue?vue&type=script&lang=js&"
export * from "./GIS.vue?vue&type=script&lang=js&"
import style0 from "./GIS.vue?vue&type=style&index=0&id=38664b15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38664b15",
  null
  
)

export default component.exports